import React, { FunctionComponent } from 'react'
import Image from 'next/image'
import { Flex } from '@afterpaytouch/core'
import { BASE_PATH } from '../../../../env'

export const HeroImage: FunctionComponent = () => {
  const imageSrc = [BASE_PATH, 'images/apple-retail-nux-hero.svg'].join('/')

  return (
    <Flex alignItems='center' justifyContent='center'>
      <Image loading='eager' src={imageSrc} alt='Afterpay calendar' width={400} height={400} />
    </Flex>
  )
}
